import RouteAccess from './route_access'
import Conf from 'ui-config'

// const mapStateToProps = ({ user }) => ({
//   selectedCluster: user.selectedCluster,
//   selectedScope: user.selectedScope,
//   selectedPage: store.get('app.menu.selectedKeys'),
//   AllAccessData: user.AllAccessData,
// })

// connect(mapStateToProps)

// True when the tenant-admin Customer Stats view is on and the signed-in role
// (localStorage 'UserAcc', set by the login saga before it builds the menu) is a
// tenant admin but not Root. Mirrors isTenantAdminView in pages/system/customer-stats.
const isTenantAdminOnly = () => {
  if (!Conf.CUSTOMER_STATS_TENANT_ENABLED) return false
  let userAccess = null
  try {
    userAccess = window.localStorage.getItem('UserAcc')
  } catch (e) {
    return false
  }
  if (!userAccess || RouteAccess.ROOT_ROLES.indexOf(userAccess) !== -1) return false
  return RouteAccess.TENANT_ADMIN_ROLES.indexOf(userAccess) !== -1
}

export default async function getMenuData() {
  const cluster_id = window.location.hash.replace('#/', '').split('/')[0]
  var scope_id = ''
  if (typeof window.location.hash.replace('#/', '').split('/')[1] !== 'undefined') {
    if (window.location.hash.replace('#/', '').split('/')[1] !== 'admin') {
      scope_id = '/' + window.location.hash.replace('#/', '').split('/')[1]
    }
  }

  return [
    {
      title: 'Dashboards',
      key: 'dashboard',
      icon: 'far fa-tachometer-alt',
      roles: []
        .concat(RouteAccess.SEC_ENGINEERS_ROLES)
        .concat(RouteAccess.SEC_ANALYSTS_ROLES)
        .concat(RouteAccess.VIEWER_ROLES),
      url: '/' + cluster_id + scope_id + '/dashboard',
      urlEnd: '/dashboard',
    },
    {
      title: 'Find',
      key: 'find',
      icon: 'far fa-search',
      roles: []
        .concat(RouteAccess.SEC_ENGINEERS_ROLES)
        .concat(RouteAccess.SEC_ANALYSTS_ROLES)
        .concat(RouteAccess.VIEWER_ROLES),
      url: '/' + cluster_id + scope_id + '/workbook/new',
      urlEnd: '/workbook/new',
    },
    {
      title: 'Cases',
      key: 'cases',
      icon: 'far fa-briefcase',
      roles: []
        .concat(RouteAccess.SEC_ENGINEERS_ROLES)
        .concat(RouteAccess.SEC_ANALYSTS_ROLES)
        .concat(RouteAccess.VIEWER_ROLES),
      url: '/' + cluster_id + scope_id + '/incident/cases',
      urlEnd: '/incident/cases',
    },
    {
      title: 'Signals',
      key: 'signal',
      icon: 'far fa-signal-stream',
      roles: []
        .concat(RouteAccess.SEC_ENGINEERS_ROLES)
        .concat(RouteAccess.SEC_ANALYSTS_ROLES)
        .concat(RouteAccess.VIEWER_ROLES),
      url: '/' + cluster_id + scope_id + '/incident/signals',
      urlEnd: '/incident/signals',
    },
    {
      title: 'Workbooks',
      key: 'workbook',
      icon: 'far fa-book',
      roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.SEC_ANALYSTS_ROLES),
      url: '/' + cluster_id + scope_id + '/workbook',
      urlEnd: '/workbook',
    },
    {
      title: 'Reports',
      key: 'reports',
      icon: 'far fa-file-chart-line',
      roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.SEC_ANALYSTS_ROLES),
      url: '/' + cluster_id + scope_id + '/reports',
      urlEnd: '/reports',
    },
    {
      title: 'MITRE ATT&CK',
      key: 'mitre_attack',
      icon: 'far fa-link',
      roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.SEC_ANALYSTS_ROLES),
      url: '/' + cluster_id + scope_id + '/mitre_attack',
      urlEnd: '/mitre_attack',
    },
    {
      title: 'Streams',
      key: 'streams',
      icon: 'far fa-waveform-path',
      roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.VIEWER_ROLES),
      url: '/' + cluster_id + scope_id + '/stream/list',
      urlEnd: '/stream/list',
    },
    {
      title: 'EBA',
      key: 'eba',
      icon: 'far fa-user-chart',
      roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES),
      url: '/' + cluster_id + scope_id + '/eba',
      urlEnd: '/eba',
    },
    {
      category: true,
      key: 'system',
      title: '',
      roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES)
        .concat(RouteAccess.ORG_ADMIN_ROLES)
        .concat(RouteAccess.ROOT_ROLES)
        .concat(RouteAccess.ROOT_INIT_ROLES)
        .concat(RouteAccess.ROOT_VIEWER_ROLES)
        .concat(RouteAccess.CONTENT_MNGR_ROLES)
        .concat(RouteAccess.VIEWER_ROLES),
    },
    {
      title: 'System',
      key: 'system',
      icon: 'far fa-tv',
      roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES)
        .concat(RouteAccess.ORG_ADMIN_ROLES)
        .concat(RouteAccess.ROOT_ROLES)
        .concat(RouteAccess.ROOT_INIT_ROLES)
        .concat(RouteAccess.ROOT_VIEWER_ROLES)
        .concat(RouteAccess.CONTENT_MNGR_ROLES)
        .concat(RouteAccess.VIEWER_ROLES),
      children: [
        {
          title: 'Utilization',
          key: 'utilization',
          // roles: RouteAccess.SEC_ENGINEERS_ROLES.concat(RouteAccess.SEC_TENANT_ADMIN_ROLES),
          roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
            .concat(RouteAccess.ROOT_INIT_ROLES)
            .concat(RouteAccess.ROOT_VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/system/utilization',
          urlEnd: '/system/utilization',
        },
        ...(Conf.CUSTOMER_STATS_ENABLED
          ? [
              {
                title: isTenantAdminOnly() ? 'Usage & health' : 'Customer Stats',
                key: 'customerStats',
                // Root only, matching lc-api (no Root viewers: bloo-team/saas-console#481).
                // Tenant admins too when CUSTOMER_STATS_TENANT_ENABLED (bloo-team/saas-console#469).
                roles: RouteAccess.ROOT_ROLES.concat(
                  Conf.CUSTOMER_STATS_TENANT_ENABLED ? RouteAccess.TENANT_ADMIN_ROLES : [],
                ),
                url: '/' + cluster_id + scope_id + '/system/customer-stats',
                urlEnd: '/system/customer-stats',
              },
            ]
          : []),
        {
          title: 'Collection Status',
          key: 'collection_status',
          roles: RouteAccess.SEC_ENGINEERS_ROLES.concat(RouteAccess.TENANT_ADMIN_ROLES)
            .concat(RouteAccess.ROOT_ROLES)
            .concat(RouteAccess.ROOT_INIT_ROLES)
            .concat(RouteAccess.ROOT_VIEWER_ROLES)
            .concat(RouteAccess.VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/system/collection_status',
          urlEnd: '/system/collection_status',
        },
        {
          title: 'Enrichment',
          key: 'enrichment',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/enrichment',
          urlEnd: '/system/enrichment',
        },
        {
          title: 'Eventstores',
          key: 'events',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/eventstores',
          urlEnd: '/system/eventstores',
        },
        {
          title: 'Extraction',
          key: 'extraction',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/extraction',
          urlEnd: '/system/extraction',
        },
        {
          title: 'Geo Enrichment',
          key: 'geodb',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/geodb',
          urlEnd: '/system/geodb',
        },
        {
          title: 'Automation',
          key: 'automation',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/integrations',
          urlEnd: '/system/integrations',
        },
        {
          title: 'Signal Suppression Rules',
          key: 'signalsuppression',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/signalsuppression',
          urlEnd: '/system/signalsuppression',
        },
        {
          title: 'Slow Queries',
          key: 'slowQuery',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/slow-queries',
          urlEnd: '/system/slow-queries',
        },
        {
          title: 'Manage Tokens',
          key: 'token',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/token',
          urlEnd: '/system/token',
        },
        {
          title: 'Machine Learning',
          key: 'models',
          roles: RouteAccess.SEC_ENGINEERS_ROLES,
          url: '/' + cluster_id + scope_id + '/system/models',
          urlEnd: '/system/models',
        },
        {
          title: 'Administration',
          key: 'secadmin',
          roles: RouteAccess.TENANT_ADMIN_ROLES,
          url: '/' + cluster_id + scope_id + '/system/components',
          urlEnd: '/system/components',
        },
        {
          title: 'Data Sources',
          key: 'connectors',
          roles: RouteAccess.TENANT_ADMIN_ROLES,
          url: '/' + cluster_id + scope_id + '/system/connectors',
          urlEnd: '/system/connectors',
        },
        {
          title: 'Tenants',
          key: 'tenants',
          roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
            .concat(RouteAccess.ROOT_INIT_ROLES)
            .concat(RouteAccess.ROOT_VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/admin/tenants/list',
          urlEnd: '/admin/tenants/list',
        },
        {
          title: 'Organizations',
          key: 'organization',
          roles: RouteAccess.ORG_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
            .concat(RouteAccess.ROOT_INIT_ROLES)
            .concat(RouteAccess.ROOT_VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/admin/organizations/list',
          urlEnd: '/admin/organizations/list',
        },
        // {
        //   title: 'Users',
        //   key: 'user',
        //   roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_INIT_ROLES),
        //   url: '/' + cluster_id + scope_id + '/admin/users/list',
        //   urlEnd: '/admin/users/list',
        // },
        {
          title: 'Data Model',
          key: 'streamfieldaddition',
          roles: RouteAccess.CONTENT_MNGR_ROLES,
          url: '/' + cluster_id + scope_id + '/system/streamfieldaddition',
          urlEnd: '/system/streamfieldaddition',
        },
      ],
    },
    {
      category: true,
      key: 'admin',
      title: '',
      roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_INIT_ROLES).concat(
        RouteAccess.ROOT_VIEWER_ROLES,
      ),
    },
    {
      title: 'Administration',
      key: 'admin',
      icon: 'far fa-lock',
      roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
      children: [
        {
          title: 'Configure SMTP',
          key: 'smtp',
          roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/admin/smtp',
          urlEnd: '/admin/smtp',
        },
        {
          title: 'Mission Control',
          key: 'clusters',
          roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/admin/clusters',
          urlEnd: '/admin/clusters',
        },
        {
          title: 'Manage Components',
          key: 'components',
          roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/admin/components',
          urlEnd: '/admin/components',
        },
        {
          title: 'Switchboard',
          key: 'switch',
          roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
          url: '/' + cluster_id + scope_id + '/admin/switchboard',
          urlEnd: '/admin/switchboard',
        },
      ],
    },
  ]
}
